/* eslint-disable import/prefer-default-export */

import { APP } from 'src/store/ActionTypes';

export const submitFeedback = (page, feedback) => ({
  type: APP.SUBMIT_FEEDBACK,
  payload: {
    page,
    feedback,
  },
});

export const toggleMenu = () => ({
  type: APP.TOGGLE_MENU,
});

export const fetchClients = () => ({
  type: APP.FETCH_CLIENTS,
});

export const setTenant = (tenant) => ({
  type: APP.SET_TENANT,
  payload: tenant,
});

export const selectClient = (client) => ({
  type: APP.SELECT_CLIENT,
  payload: client,
});

export const setClient = (client) => ({
  type: APP.SET_CLIENT,
  payload: client,
});

export const fetchProfile = () => ({
  type: APP.FETCH_PROFILE,
});

export const setSegmentId = (segmentId) => ({
  type: APP.SET_SEGMENT_ID,
  payload: segmentId,
});

export const fetchDatasets = (query) => ({
  type: APP.FETCH_DATASETS,
  payload: query,
});

export const setDatasetId = (datasetId) => ({
  type: APP.SET_DATASET_ID,
  payload: datasetId,
});

export const register = (payload) => ({
  type: APP.REGISTER,
  payload,
});

export const addClient = (payload) => ({
  type: APP.ADD_CLIENT,
  payload,
});

export const delClient = (tenant) => ({
  type: APP.DEL_CLIENT,
  payload: tenant,
});

export const unset = (payload) => ({
  type: APP.UNSET,
  payload,
});

export const selectDatasetId = (dataset) => ({
  type: APP.SELECT_DATASET_ID,
  payload: dataset,
});

export const deselectDatasetId = (dataset) => ({
  type: APP.DESELECT_DATASET_ID,
  payload: dataset,
});

export const deselectAllDatasetIds = () => ({
  type: APP.DESELECT_ALL_DATASET_IDS,
});

/**
 * enqueue a notification for display
 * @param {string} message - the message to display in the toast
 * @param {Object} options - options passed to the toast library
 * @param {boolean=} [options.autoClose] - auto-close the notification
 * @param {number=} [options.timeout] - time to wait for auto-closing in ms
 */
export const enqueueNotification = (message, options = {}) => ({
  type: APP.ENQUEUE_NOTIFICATION,
  payload: {
    message,
    options,
  },
});

export const dequeueNotification = () => ({
  type: APP.DEQUEUE_NOTIFICATION,
});

export const flashMessage = (message, options = {}) => ({
  type: APP.FLASH_MESSAGE,
  payload: {
    message,
    options,
  },
});

export const hideMessage = () => ({
  type: APP.HIDE_MESSAGE,
});

export const setTourSteps = (steps) => ({
  type: APP.SET_TOUR_STEPS,
  payload: steps,
});

export const openTour = () => ({
  type: APP.OPEN_TOUR,
});

export const closeTour = () => ({
  type: APP.CLOSE_TOUR,
});

export const setFlyoverOpenStatus = (status) => ({
  type: APP.SET_FLYOVER_OPEN_STATUS,
  payload: status,
});

export const setFlyoverPinStatus = (status) => ({
  type: APP.SET_FLYOVER_PIN_STATUS,
  payload: status,
});

export const getPresignedUrl = (bucket, key) => ({
  type: APP.GET_PRESIGNED_URL,
  payload: { bucket, key },
});

export const getFileViaSignedUrl = (bucket, key) => ({
  type: APP.GET_URL_FOR_DL,
  payload: { bucket, key },
});
